// Environment configuration loader
// This script loads configuration from app-config.json and updates the environment object

import { environment } from './environment';
import { LogLevel } from '../app/services/logLevel.enum';

export interface AppConfig {
  production: boolean;
  protocol: string;
  host: string;
  LogLevel: LogLevel;
  sharepointPickerClientId: string;
  sharepointEndpointHint: string;
}

// Function to load configuration and update environment
export async function loadConfig(): Promise<void> {
  try {
    // Add cache-busting parameter to prevent caching
    const cacheBuster = Date.now();
    const response = await fetch(`/assets/config/app-config.json?v=${cacheBuster}`, {
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
    if (!response.ok) {
      throw new Error(`Failed to load config: ${response.status}`);
    }

    const config: AppConfig = await response.json();

    // Update environment object with values from JSON
    Object.assign(environment, {
      production: config.production,
      protocol: config.protocol,
      host: config.host,
      LogLevel: config.LogLevel,
      sharepointPickerClientId: config.sharepointPickerClientId,
      sharepointEndpointHint: config.sharepointEndpointHint
    });

  } catch (error) {
    console.error('Failed to load configuration, using default environment values:', error);
    // Environment already has fallback values, so no action needed
  }
}
